<template>
  <div class="meta_box">
    <div class="descp1">
      {{ $t('promotion.depositBonus.opt') }}
    </div>
    <br />
    <div class="center_row">
      <el-form :model="form" ref="optForm" :show-message="false">
        <el-form-item prop="checked" class="checkbox">
          <el-checkbox v-model="form.checked" data-testid="checkbox"> </el-checkbox>
        </el-form-item>
      </el-form>
      <div class="descp2" v-html="$t('promotion.depositBonus.tick')"></div>
    </div>
    <div class="button_box">
      <el-button class="el-button blue_button" data-testid="opt" @click="postDespositBonusOpt">
        {{ $t('promotion.depositBonus.saveChange') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { apiCampaignOpt } from '@/resource';

export default {
  name: 'optInOut',
  props: { optIn: Boolean },
  data() {
    return {
      form: {
        checked: true
      }
    };
  },
  watch: {
    optIn: {
      immediate: true,
      handler(val) {
        this.form.checked = val;
      }
    }
  },
  computed: {
    campaignID() {
      return this.$route.params && this.$route.params.campaignId ? this.$route.params.campaignId : null;
    }
  },
  methods: {
    postDespositBonusOpt() {
      if (!this.campaignID) return;
      apiCampaignOpt(this.campaignID, this.form.checked)
        .then(resp => {
          if (resp.data.data) {
            this.$emit('successfulCallback', this.form.checked);
          } else {
            this.$message({
              message: this.$t('common.field.failed'),
              type: 'error',
              duration: 5000
            });
            this.form.checked = this.optIn;
          }
        })
        .catch(err => {
          this.$message({
            message: this.$t('common.field.failed'),
            type: 'error',
            duration: 5000
          });
          this.form.checked = this.optIn;
        });
    }
  }
};
</script>
